import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import Label from "%/dynamic-component-editor/options/label";
import DynamicElement from "%/dynamic-component-editor/classes/dynamic-element";
import useDynamicComponentEditorStore from "%/dynamic-component-editor/stores/dynamic-component-editor";

const LABEL_OPTION_KEY = "label";

// A button whose text is the `label` option (the key mobile reads), with the bundle's own
// text + link fields hidden because the element owns its click.
export const LabelButtonMixin = {
  optionBundles: [
    new ButtonOptions({}, {
      "text-option": true,
      "link-type": true,
      "href-option": true,
    }),
  ],
  computed: {
    textValueOptionClass() {
      return Label;
    },
  },
  methods: {
    commitTextOption(value) {
      const [state, breakpoint] = useDynamicComponentEditorStore().activeState.split(":");
      DynamicElement.get(this.identifier)?.updateOption(LABEL_OPTION_KEY, breakpoint, state, value);
    },
  },
};
